import React from "react"
import { SectionTitle, DataTable, PaginationControls } from "../components"
import { cardStyle, loadingStyle } from "../styles/commonStyles"
import { formatThaiBuddhistDate } from "../../../libs/dateUtils"
import { getPaginationInfo } from "../utils/helpers"
import { COLORS, TYPOGRAPHY } from "../constants/theme"

const UserLogsTab = ({ data: userLogs, loading, currentPage, totalPages, totalCount, perPage, fetchData, userId }) => {
	const { indexOfFirstItem } = getPaginationInfo(currentPage, perPage, totalCount)

	const handlePageChange = (page) => {
		if (userId) {
			fetchData(userId, page)
		}
	}

	const syntaxHighlight = (json) => {
		if (!json) return ""

		if (typeof json !== "string") {
			json = JSON.stringify(json, null, 2)
		}

		json = json
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\""])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g, (match) => {
				let cls = "number"
				if (/^"/.test(match)) {
					if (/:$/.test(match)) {
						cls = "key"
					} else {
						cls = "string"
					}
				} else if (/true|false/.test(match)) {
					cls = "boolean"
				} else if (/null/.test(match)) {
					cls = "null"
				}
				return `<span class="${cls}">${match}</span>`
			})
		return json
	}

	const headers = ["#", "วันที่สร้าง", "ประเภท", "ข้อมูล"]

	const rows = (userLogs || []).map((log, index) => [
		`${indexOfFirstItem + index}.`,
		formatThaiBuddhistDate(log.create_date),
		log.type,
		log.data ? (
			<pre
				key="data"
				dangerouslySetInnerHTML={{
					__html: syntaxHighlight(log.data),
				}}
				style={{
					margin: 0,
					padding: "8px",
					backgroundColor: COLORS.gray50,
					borderRadius: "4px",
					fontSize: TYPOGRAPHY.fontSize.xs,
					lineHeight: TYPOGRAPHY.lineHeight.normal,
					whiteSpace: "pre-wrap",
					wordBreak: "break-word",
					overflow: "auto",
					maxHeight: "300px",
					// maxWidth: "400px",
					border: `1px solid ${COLORS.border}`,
				}}
			/>
		) : (
			""
		),
	])

	return (
		<div className="card-style" style={cardStyle}>
			<SectionTitle title="บันทึกการดำเนินการ" />

			{loading && (
				<div
					style={{
						...loadingStyle,
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						background: "rgba(255,255,255,0.8)",
						zIndex: 10,
					}}
				>
					กำลังโหลด...
				</div>
			)}

			<div style={{ position: "relative", opacity: loading ? 0.6 : 1 }}>
				<DataTable headers={headers} rows={rows} emptyMessage="ไม่พบข้อมูลการดำเนินการ" widths={["50px", "200px", "200px", "auto"]} />

				{totalPages > 1 && (
					<PaginationControls
						currentPage={currentPage}
						totalPages={totalPages}
						totalCount={totalCount}
						perPage={perPage}
						isLoading={loading}
						onPageChange={handlePageChange}
					/>
				)}
			</div>
		</div>
	)
}

export default UserLogsTab
